const tooltip = {
  renderer: ({
    yKey,
    xValue,
    yValue,
  }: {
    yKey: string;
    xValue: any;
    yValue: any;
  }) => ({
    content: `${xValue}: ${yValue}`,
    title: yKey,
  }),
};

export const series = [
  {
    marker: {
      fill: "#494b8f",
      stroke: "#494b8f",
    },
    stroke: "#494b8f",
    tooltip,
    type: "line",
    xKey: "date",
    yKey: "student",
  },
  {
    marker: {
      fill: "#EC4E20",
      stroke: "#EC4E20",
    },
    stroke: "#EC4E20",
    tooltip,
    type: "line",
    xKey: "date",
    yKey: "teacher",
  },
];

export const axes = [
  {
    label: {
      autoRotate: true,
    },
    position: "bottom",
    type: "category",
  },
  {
    base: 2,
    max: 10,
    min: 0,
    position: "left",
    type: "number",
  },
];

export const chartTheme = {
  overrides: {
    line: {
      series: {
        highlightStyle: {
          series: {
            dimOpacity: 0.2,
            strokeWidth: 3,
          },
        },
      },
    },
  },
};

export const getTitleConfig = (text: string) => ({
  fontSize: 18,
  text,
});



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/components/SurveyCharts/config.ts